import { fetch } from '@maxtropy/components';

export interface DataProperty {
  id: number;
  name: string;
}
export function getAllDataPropertyList(): Promise<DataProperty[]> {
  return fetch(`/api/dataProperty/all-list`);
}
